import { combineReducers, createStore } from 'redux';
import { routerReducer } from 'react-router-redux';
import { localizeReducer } from 'react-localize-redux';
import { reducer as toastrReducer } from 'react-redux-toastr';

export const makeRootReducer = (asyncReducers) => {
  return combineReducers({
    routing: routerReducer,
    locale: localizeReducer,
    domain: function (state = {}, action) {
      if (action && action.type === 'DOMAIN') {
        return action.data;
      }
      return state;
    },
    user: function (state = {}, action) {
      if (action && action.type === 'USER') {
        return action.user;
      }
      return state;
    },
    studio: function (state = {}, action) {
      if (action && action.type === 'STUDIO') {
        return action.studio;
      }
      return state;
    },
    classInfo: function (state = {}, action) {
      if (action && action.type === 'CLASS_INFO') {
        return action.classInfo;
      }
      return state;
    },
    errorData: function (state = {}, action) {
      if (action && action.type === 'ERROR') {
        return action.data;
      }
      return state;
    },
    needLogin: function (state = {}, action) {
      if (action && action.type === 'NEED_LOGIN') {
        return action.show;
      }
      return state;
    },
    birthdays: function (state = {}, action) {
      if (action && action.type === 'BIRTHDAYS') {
        return action.data;
      }
      return state;
    },
    myStudios: function (state = {}, action) {
      if (action && action.type === 'MY_STUDIOS') {
        return action.data;
      }
      return state;
    },
    selectedAttendanceWeek: function (state = {}, action) {
      if (action && action.type === 'SELECTED_ATTENDANCE_WEEK') {
        return action.week;
      }
      return state;
    },
    subscription: function (state = {}, action) {
      if (action && action.type === 'SUBSCRIPTION') {
        return action.subscription;
      }
      return state;
    },
    navigationSettings: function (state = {}, action) {
      if (action && action.type === 'NAVIGATION_SETTINGS') {
        return action.navigationSettings;
      }
      return state;
    },
    toastr: toastrReducer,
    ...asyncReducers,
  });
};

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;

  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer(store.asyncReducers));
};

export default makeRootReducer;
